<emm-legend-items [items]="legendItems"></emm-legend-items>
<div class *ngIf="fields.length > 0 && itemDetail$ | async">
    <mat-accordion [multi]="true">
        <div *ngFor="let attributeGroup of attributeGroups">
            <mat-expansion-panel
                *ngIf="hasValue(attributeGroup.id)"
                [ngClass]="{ 'attribute-group-open': attributeGroup == selectedStatus }"
                (closed)="closePanel(attributeGroup)"
                (opened)="openPanel(attributeGroup)"
                [expanded]="previousAttributeGroups ? isPreviousPanel(attributeGroup) : false"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title [attr.data-testid]="attributeGroup.name">
                        {{ attributeGroup.name }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <emm-dynamic-management-form *ngIf="renderForm | async"
                                  [attributes]="attributesByGroup.get(attributeGroup.id) | async"
                                  [attributeGroupId]="attributeGroup.id"
                                  [locked]="item.locked"
                                  [itemTag]="item.tag"
                                  [form]="form | async"
                                  [locale]="sharedFacade.localeSelected$ | async"
                ></emm-dynamic-management-form>
            </mat-expansion-panel>
        </div>
    </mat-accordion>
    <br>
    <emm-attribute-updated-info
        *ngIf="item.lastUpdatedBy || item.lastUpdatedDate"
        [lastUpdatedBy]="item.lastUpdatedBy"
        [lastUpdatedDate]="item.lastUpdatedDate"
    ></emm-attribute-updated-info>
    <div id="customSnackbar">
        <button mat-icon-button class="close" (click)="closeCustomSnackbar()">
            <mat-icon matTooltip="Close this message">close</mat-icon>
        </button>
        <div class="d-flex flex-column align-items-center">
            <strong>The Meal attribute is now set automatically</strong>
            <p>The Meal attribute is now set automatically on item creation and may not be modified.
                Your update was saved with this change excluded.</p>
        </div>
    </div>
    <div class="fixed-buttons-row">
        <button mat-raised-button
                [disabled]="!hasChanges() || hasInvalidFormfield()"
                (click)="submitAllDirtyAttributeGroups(item.tag)"
        >Update
        </button>
        <button mat-raised-button
                [disabled]="!hasChanges()"
                (click)="cancelAllDirtyAttributeGroups()"
        >Cancel
        </button>
    </div>
</div>
